import { render, staticRenderFns } from "./customField_list.vue?vue&type=template&id=b913d4b6&"
import script from "./customField_list.vue?vue&type=script&lang=js&"
export * from "./customField_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports